import { useEffect, useRef } from 'react'
import { WEBVIEW_RESUME } from '../utils/customEvents'
import { useDevWebViewPageVisibilityFallback } from './useDevWebViewPageVisibilityFallback'

type UseWebViewPageVisibilityOptions = {
  onResume?: () => void
  enabled?: boolean
}

export function useWebViewPageVisibility(options: UseWebViewPageVisibilityOptions = {}) {
  const { onResume, enabled = true } = options
  const onResumeRef = useRef(onResume)

  useEffect(() => {
    onResumeRef.current = onResume
  }, [onResume])

  useDevWebViewPageVisibilityFallback({ onResume, enabled })

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') {
      return
    }

    const handleNativeResume = () => {
      onResumeRef.current?.()
    }

    window.addEventListener(WEBVIEW_RESUME, handleNativeResume)
    return () => {
      window.removeEventListener(WEBVIEW_RESUME, handleNativeResume)
    }
  }, [enabled])
}
